import React from "react";
import PropTypes from "prop-types";
import {
  CoordinatesShape,
  LocationInputShape,
} from "theme/components/organisms/Map/location";

const Map = () => {
  return <div>No map implementation, please enable one of the map modules</div>;
};
Map.propTypes = {
  locations: PropTypes.arrayOf(LocationInputShape).isRequired,
  getMarker: PropTypes.func.isRequired,
  zoom: PropTypes.number,
  defaultBounds: PropTypes.arrayOf(CoordinatesShape),
  defaultCenter: CoordinatesShape,
  onBoundsChanged: PropTypes.func,
};

const Marker = () => {
  return <div>No map implementation, please enable one of the map modules</div>;
};
Marker.propTypes = {
  location: LocationInputShape.isRequired,
  icon: PropTypes.shape({
    url: PropTypes.string.isRequired,
    size: PropTypes.shape({
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
    }).isRequired,
  }),
  isPopupOpened: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Map;
export { Marker };
